import { call, put, select, takeLatest } from "redux-saga/effects";
import apiClient from "../../api/apiClient";
import {
  createFieldNoteFailure,
  createFieldNoteStart,
  createFieldNoteSuccess,
  deleteFieldNoteFailure,
  deleteFieldNoteStart,
  deleteFieldNoteSuccess,
  updateFieldNoteFailure,
  updateFieldNoteStart,
  updateFieldNoteSuccess,
} from "../../store/features/fieldNote/fieldNoteSlice";

const relativeUrl = "/api/v1/field_note/field_note/";

const selectAccessToken = (state) => state.auth?.user?.access_token;

// CREATE
const createFieldNoteApi = async ({ data, accessToken }) => {
  try {
    const client = apiClient(accessToken, relativeUrl);
    const formData = new FormData();
    formData.append("field", data.field);
    formData.append("note_type", data.note_type);
    formData.append("description", data.description);
    formData.append("title", data.title);
    if (data.disease) formData.append("disease", data.disease);
    if (data.position && data.position.length > 0) {
      formData.append("position", JSON.stringify(data.position));
    }

    data.photo.forEach((file) => {
      formData.append("photo", file);
    });
    const response = await client.post("/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
};

function* handleCreateFieldNoteSaga(action) {
  try {
    const data = yield call(createFieldNoteApi, action.payload);
    yield put(createFieldNoteSuccess(data));
  } catch (error) {
    yield put(createFieldNoteFailure(error));
  }
}

// UPDATE
const updateFieldNoteApi = async ({ data, noteId, accessToken }) => {
  try {
    const client = apiClient(accessToken, relativeUrl);

    const formData = new FormData();
    formData.append("field", data.field);
    formData.append("note_type", data.note_type);
    formData.append("description", data.description);
    formData.append("title", data.title);
    formData.append("photos", data.photos);
    if (data.disease) formData.append("disease", data.disease);
    if (data.position && data.position.length > 0) {
      formData.append("position", JSON.stringify(data.position));
    }

    if (data.newPhotos && data.newPhotos.length > 0) {
      data.newPhotos.forEach((file, index) => {
        formData.append(`photo${index + 1}`, file);
      });
    }

    const response = await client.put(`${noteId}/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
};

function* handleUpdateFieldNoteSaga(action) {
  try {
    const accessToken = yield select(selectAccessToken);
    const data = yield call(updateFieldNoteApi, {
      ...action.payload,
      accessToken,
    });
    yield put(updateFieldNoteSuccess(data));
  } catch (error) {
    yield put(updateFieldNoteFailure(error));
  }
}

// DELETE
const deleteFieldNoteApi = async ({ noteId, accessToken }) => {
  try {
    const client = apiClient(accessToken, relativeUrl);
    const response = await client.delete(`${noteId}/`);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleDeleteFielNoteSaga(action) {
  try {
    const accessToken = yield select(selectAccessToken);
    const data = yield call(deleteFieldNoteApi, {
      ...action.payload,
      accessToken,
    });
    yield put(deleteFieldNoteSuccess(data));
  } catch (error) {
    yield put(deleteFieldNoteFailure(error));
  }
}

export default function* fieldNoteSaga() {
  yield takeLatest(createFieldNoteStart.type, handleCreateFieldNoteSaga);
  yield takeLatest(updateFieldNoteStart.type, handleUpdateFieldNoteSaga);
  yield takeLatest(deleteFieldNoteStart.type, handleDeleteFielNoteSaga);
}
